import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ICellRendererParamsForCompanyPermissionsGridAction extends ICellRendererParams {
    launchSitesModal: (params: ICellRendererParamsForCompanyPermissionsGridAction) => Promise<void>;
    canLaunchSitesModal: (params: ICellRendererParamsForCompanyPermissionsGridAction) => boolean;
    editMode: (params: ICellRendererParamsForCompanyPermissionsGridAction) => boolean;
    canRemove: (params: ICellRendererParamsForCompanyPermissionsGridAction) => boolean;
    remove: (params: ICellRendererParamsForCompanyPermissionsGridAction) => void;
    canUndoRemove: (params: ICellRendererParamsForCompanyPermissionsGridAction) => boolean;
    undoRemove: (params: ICellRendererParamsForCompanyPermissionsGridAction) => void;
}

@Component({
    selector: 'company-panel-grid-action-cell',
    template: `
    <button [style.visibility]="params.canLaunchSitesModal(params) ? 'visible' : 'hidden'" type="button" class="ace-btn btn-primary has-icon grid-action-button" helpTooltip [helpContentId]="helpContentId" (click)="params.launchSitesModal(params)">
      @if (params.editMode(params)) {
        <i class="fa fa-pencil"></i>
      }
      @if (!params.editMode(params)) {
        <i class="fa fa-eye"></i>
      }
    </button>
    @if (params.canRemove(params)) {
      <button class="ace-btn has-icon btn-primary btn-danger grid-action-button" title="Remove" (click)="params.remove(params)">
        <i class="fa fa-trash"></i>
      </button>
    }
    @if (params.canUndoRemove(params)) {
      <button class="ace-btn has-icon success-button grid-action-button" title="Undo Remove" (click)="params.undoRemove(params)">
        <i class="fa fa-undo"></i>
      </button>
    }
    `,
    standalone: false
})
export class CompanyPermissionsGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForCompanyPermissionsGridAction;
    helpContentId: string;

    agInit(params: ICellRendererParamsForCompanyPermissionsGridAction): void {
        this.params = params;
        this.helpContentId = this.params.editMode(this.params) ? 'user-group-detail.edit-site-permissions' : 'user-group-detail.view-site-permissions';
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
